export default __webpack_public_path__ + "static/media/queshengye-kejian.a8c4d41f.png";